var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column align-center justify-content-center"},[_c('v-progress-circular',{attrs:{"color":"accent","size":_vm.size,"value":_vm.percentage,"rotate":-90,"rounded":""}},[_c('strong',{staticClass:"text-content"},[_vm._v(_vm._s(_vm.percentageText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }